@file:OptIn(InternalResourceApi::class)

package iraniancanadienbazzar.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/iraniancanadienbazzar.shared.generated.resources/"

@delegate:ResourceContentHash(-1_972_576_045)
internal val Res.string.action_add_claim_business: StringResource by lazy {
      StringResource("string:action_add_claim_business", "action_add_claim_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 65),
      ))
    }

@delegate:ResourceContentHash(-1_254_600_474)
internal val Res.string.action_continue_as_user: StringResource by lazy {
      StringResource("string:action_continue_as_user", "action_continue_as_user", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 120, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 92, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76, 55),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.action_retry: StringResource by lazy {
      StringResource("string:action_retry", "action_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 204, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132, 32),
      ))
    }

@delegate:ResourceContentHash(-487_658_837)
internal val Res.string.action_sign_in: StringResource by lazy {
      StringResource("string:action_sign_in", "action_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 253, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 201, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165, 34),
      ))
    }

@delegate:ResourceContentHash(35_704_243)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 288, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 240, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200, 28),
      ))
    }

@delegate:ResourceContentHash(-77_258_632)
internal val Res.string.app_tagline: StringResource by lazy {
      StringResource("string:app_tagline", "app_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 317, 179),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 269, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 229, 103),
      ))
    }

@delegate:ResourceContentHash(339_358_431)
internal val Res.string.delete_account_cancel: StringResource by lazy {
      StringResource("string:delete_account_cancel", "delete_account_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 497, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 401, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 333, 37),
      ))
    }

@delegate:ResourceContentHash(-1_589_008_758)
internal val Res.string.delete_account_confirm: StringResource by lazy {
      StringResource("string:delete_account_confirm", "delete_account_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 543, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 443, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 371, 50),
      ))
    }

@delegate:ResourceContentHash(1_055_937_567)
internal val Res.string.delete_account_failed: StringResource by lazy {
      StringResource("string:delete_account_failed", "delete_account_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 610, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 510, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 422, 89),
      ))
    }

@delegate:ResourceContentHash(-855_726_341)
internal val Res.string.delete_account_password_label: StringResource by lazy {
      StringResource("string:delete_account_password_label", "delete_account_password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 732, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 608, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 512, 65),
      ))
    }

@delegate:ResourceContentHash(410_434_576)
internal val Res.string.delete_account_title: StringResource by lazy {
      StringResource("string:delete_account_title", "delete_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 834, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 686, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 578, 48),
      ))
    }

@delegate:ResourceContentHash(-718_435_033)
internal val Res.string.delete_account_warning: StringResource by lazy {
      StringResource("string:delete_account_warning", "delete_account_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 887, 314),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 743, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 627, 174),
      ))
    }

@delegate:ResourceContentHash(1_110_088_666)
internal val Res.string.delete_account_wrong_password: StringResource by lazy {
      StringResource("string:delete_account_wrong_password", "delete_account_wrong_password", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1202, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 954, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 802, 81),
      ))
    }

@delegate:ResourceContentHash(-1_760_373_964)
internal val Res.string.gate_debug_dismiss: StringResource by lazy {
      StringResource("string:gate_debug_dismiss", "gate_debug_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1336, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1044, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 884, 58),
      ))
    }

@delegate:ResourceContentHash(-761_944_516)
internal val Res.string.gate_maintenance_message_default: StringResource by lazy {
      StringResource("string:gate_maintenance_message_default", "gate_maintenance_message_default", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1423, 220),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1091, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 943, 140),
      ))
    }

@delegate:ResourceContentHash(96_755_638)
internal val Res.string.gate_maintenance_title: StringResource by lazy {
      StringResource("string:gate_maintenance_title", "gate_maintenance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1644, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1244, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1084, 58),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.gate_retry: StringResource by lazy {
      StringResource("string:gate_retry", "gate_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1727, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1311, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1143, 30),
      ))
    }

@delegate:ResourceContentHash(1_556_441_588)
internal val Res.string.gate_update_button: StringResource by lazy {
      StringResource("string:gate_update_button", "gate_update_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1774, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1346, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 42),
      ))
    }

@delegate:ResourceContentHash(-1_023_867_947)
internal val Res.string.gate_update_message_default: StringResource by lazy {
      StringResource("string:gate_update_message_default", "gate_update_message_default", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1833, 231),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1393, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1217, 155),
      ))
    }

@delegate:ResourceContentHash(-1_300_234_826)
internal val Res.string.gate_update_title: StringResource by lazy {
      StringResource("string:gate_update_title", "gate_update_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2065, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1585, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1373, 45),
      ))
    }

@delegate:ResourceContentHash(1_896_734_237)
internal val Res.string.label_sponsored: StringResource by lazy {
      StringResource("string:label_sponsored", "label_sponsored", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2143, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1639, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1419, 35),
      ))
    }

@delegate:ResourceContentHash(-434_120_505)
internal val Res.string.label_verified: StringResource by lazy {
      StringResource("string:label_verified", "label_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2195, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1679, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1455, 34),
      ))
    }

@delegate:ResourceContentHash(1_297_465_390)
internal val Res.string.mock_data_banner: StringResource by lazy {
      StringResource("string:mock_data_banner", "mock_data_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2242, 216),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1714, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1490, 116),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.nav_events: StringResource by lazy {
      StringResource("string:nav_events", "nav_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2459, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1871, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1607, 26),
      ))
    }

@delegate:ResourceContentHash(-995_725_307)
internal val Res.string.nav_feed: StringResource by lazy {
      StringResource("string:nav_feed", "nav_feed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2502, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1906, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1634, 24),
      ))
    }

@delegate:ResourceContentHash(-1_447_795_657)
internal val Res.string.nav_home: StringResource by lazy {
      StringResource("string:nav_home", "nav_home", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2535, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1927, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1659, 24),
      ))
    }

@delegate:ResourceContentHash(-1_466_384_413)
internal val Res.string.nav_market: StringResource by lazy {
      StringResource("string:nav_market", "nav_market", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2564, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1956, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1684, 26),
      ))
    }

@delegate:ResourceContentHash(-784_944_236)
internal val Res.string.nav_messages: StringResource by lazy {
      StringResource("string:nav_messages", "nav_messages", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2599, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1987, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1711, 32),
      ))
    }

@delegate:ResourceContentHash(910_572_629)
internal val Res.string.nav_notifications: StringResource by lazy {
      StringResource("string:nav_notifications", "nav_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2730, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2094, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1818, 45),
      ))
    }

@delegate:ResourceContentHash(-857_252_211)
internal val Res.string.nav_notifications_unread_a11y: StringResource by lazy {
      StringResource("string:nav_notifications_unread_a11y", "nav_notifications_unread_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2640, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2020, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1744, 73),
      ))
    }

@delegate:ResourceContentHash(-160_265_374)
internal val Res.string.nav_post: StringResource by lazy {
      StringResource("string:nav_post", "nav_post", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2780, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2140, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1864, 24),
      ))
    }

@delegate:ResourceContentHash(648_517_730)
internal val Res.string.nav_profile: StringResource by lazy {
      StringResource("string:nav_profile", "nav_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2805, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2169, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1889, 31),
      ))
    }

@delegate:ResourceContentHash(1_333_017_947)
internal val Res.string.offline_banner: StringResource by lazy {
      StringResource("string:offline_banner", "offline_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2845, 262),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2197, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1921, 146),
      ))
    }

@delegate:ResourceContentHash(2_012_619_358)
internal val Res.string.owner_welcome_body: StringResource by lazy {
      StringResource("string:owner_welcome_body", "owner_welcome_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3108, 450),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2380, 258),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2068, 218),
      ))
    }

@delegate:ResourceContentHash(1_021_737_983)
internal val Res.string.owner_welcome_later: StringResource by lazy {
      StringResource("string:owner_welcome_later", "owner_welcome_later", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3559, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2639, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2287, 35),
      ))
    }

@delegate:ResourceContentHash(30_855_423)
internal val Res.string.owner_welcome_title: StringResource by lazy {
      StringResource("string:owner_welcome_title", "owner_welcome_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3603, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2679, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2323, 55),
      ))
    }

@delegate:ResourceContentHash(-1_451_873_087)
internal val Res.string.owner_welcome_tour: StringResource by lazy {
      StringResource("string:owner_welcome_tour", "owner_welcome_tour", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3687, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2743, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2379, 46),
      ))
    }

@delegate:ResourceContentHash(1_338_429_484)
internal val Res.string.placeholder_desc: StringResource by lazy {
      StringResource("string:placeholder_desc", "placeholder_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3738, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2790, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2426, 100),
      ))
    }

@delegate:ResourceContentHash(-2_046_945_693)
internal val Res.string.placeholder_title: StringResource by lazy {
      StringResource("string:placeholder_title", "placeholder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3859, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2907, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2527, 41),
      ))
    }

@delegate:ResourceContentHash(-994_909_605)
internal val Res.string.post_action_ask: StringResource by lazy {
      StringResource("string:post_action_ask", "post_action_ask", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3905, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2961, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2569, 59),
      ))
    }

@delegate:ResourceContentHash(-1_082_922_357)
internal val Res.string.post_action_business: StringResource by lazy {
      StringResource("string:post_action_business", "post_action_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3965, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3025, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2629, 60),
      ))
    }

@delegate:ResourceContentHash(600_747_665)
internal val Res.string.post_action_feed: StringResource by lazy {
      StringResource("string:post_action_feed", "post_action_feed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4058, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3106, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2690, 52),
      ))
    }

@delegate:ResourceContentHash(893_463_207)
internal val Res.string.post_action_market: StringResource by lazy {
      StringResource("string:post_action_market", "post_action_market", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4127, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3167, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2743, 42),
      ))
    }

@delegate:ResourceContentHash(1_938_022_998)
internal val Res.string.post_guest_cta: StringResource by lazy {
      StringResource("string:post_guest_cta", "post_guest_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4178, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3218, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2786, 62),
      ))
    }

@delegate:ResourceContentHash(1_173_610_998)
internal val Res.string.post_guest_message: StringResource by lazy {
      StringResource("string:post_guest_message", "post_guest_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4245, 370),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3285, 274),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2849, 226),
      ))
    }

@delegate:ResourceContentHash(1_313_185_552)
internal val Res.string.post_guest_title: StringResource by lazy {
      StringResource("string:post_guest_title", "post_guest_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4616, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3560, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3076, 44),
      ))
    }

@delegate:ResourceContentHash(-398_009_972)
internal val Res.string.post_sheet_title: StringResource by lazy {
      StringResource("string:post_sheet_title", "post_sheet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4693, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3621, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3121, 64),
      ))
    }

@delegate:ResourceContentHash(-921_334_845)
internal val Res.string.prod_preview_banner: StringResource by lazy {
      StringResource("string:prod_preview_banner", "prod_preview_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4786, 191),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3686, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3186, 103),
      ))
    }

@delegate:ResourceContentHash(1_372_083_264)
internal val Res.string.search_placeholder: StringResource by lazy {
      StringResource("string:search_placeholder", "search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4978, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3838, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3290, 78),
      ))
    }

@delegate:ResourceContentHash(510_419_694)
internal val Res.string.share_copy_link: StringResource by lazy {
      StringResource("string:share_copy_link", "share_copy_link", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5057, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3913, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3369, 35),
      ))
    }

@delegate:ResourceContentHash(598_158_088)
internal val Res.string.share_instagram_hint: StringResource by lazy {
      StringResource("string:share_instagram_hint", "share_instagram_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5105, 260),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3957, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3405, 144),
      ))
    }

@delegate:ResourceContentHash(-1_571_576_567)
internal val Res.string.share_more_options: StringResource by lazy {
      StringResource("string:share_more_options", "share_more_options", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5366, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4118, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3550, 42),
      ))
    }

@delegate:ResourceContentHash(222_187_175)
internal val Res.string.share_sheet_title: StringResource by lazy {
      StringResource("string:share_sheet_title", "share_sheet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5433, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4169, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3593, 33),
      ))
    }

@delegate:ResourceContentHash(1_469_785_476)
internal val Res.string.sunset_banner_default: StringResource by lazy {
      StringResource("string:sunset_banner_default", "sunset_banner_default", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5495, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4207, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3627, 133),
      ))
    }

@delegate:ResourceContentHash(1_278_967_695)
internal val Res.string.sunset_dismiss_a11y: StringResource by lazy {
      StringResource("string:sunset_dismiss_a11y", "sunset_dismiss_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5709, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4385, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3761, 47),
      ))
    }

@delegate:ResourceContentHash(1_400_206_660)
internal val Res.string.tour_done: StringResource by lazy {
      StringResource("string:tour_done", "tour_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5765, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4437, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3809, 25),
      ))
    }

@delegate:ResourceContentHash(1_485_125_231)
internal val Res.string.tour_events_body: StringResource by lazy {
      StringResource("string:tour_events_body", "tour_events_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5799, 216),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4467, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3835, 124),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.tour_events_title: StringResource by lazy {
      StringResource("string:tour_events_title", "tour_events_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6016, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4624, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3960, 33),
      ))
    }

@delegate:ResourceContentHash(1_862_506_311)
internal val Res.string.tour_feed_body: StringResource by lazy {
      StringResource("string:tour_feed_body", "tour_feed_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6066, 202),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4666, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3994, 146),
      ))
    }

@delegate:ResourceContentHash(-711_550_678)
internal val Res.string.tour_feed_title: StringResource by lazy {
      StringResource("string:tour_feed_title", "tour_feed_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6269, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4845, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4141, 43),
      ))
    }

@delegate:ResourceContentHash(1_373_982_844)
internal val Res.string.tour_home_body: StringResource by lazy {
      StringResource("string:tour_home_body", "tour_home_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6321, 290),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4893, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4185, 146),
      ))
    }

@delegate:ResourceContentHash(-741_077_701)
internal val Res.string.tour_home_title: StringResource by lazy {
      StringResource("string:tour_home_title", "tour_home_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6612, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5096, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4332, 35),
      ))
    }

@delegate:ResourceContentHash(377_743_906)
internal val Res.string.tour_market_body: StringResource by lazy {
      StringResource("string:tour_market_body", "tour_market_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6656, 208),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5136, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4368, 120),
      ))
    }

@delegate:ResourceContentHash(-2_048_219_038)
internal val Res.string.tour_market_title: StringResource by lazy {
      StringResource("string:tour_market_title", "tour_market_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6865, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5285, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4489, 41),
      ))
    }

@delegate:ResourceContentHash(115_277_704)
internal val Res.string.tour_messages_body: StringResource by lazy {
      StringResource("string:tour_messages_body", "tour_messages_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6911, 242),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5323, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4531, 138),
      ))
    }

@delegate:ResourceContentHash(-784_944_236)
internal val Res.string.tour_messages_title: StringResource by lazy {
      StringResource("string:tour_messages_title", "tour_messages_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7154, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5478, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4670, 39),
      ))
    }

@delegate:ResourceContentHash(291_023_027)
internal val Res.string.tour_next: StringResource by lazy {
      StringResource("string:tour_next", "tour_next", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7202, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5518, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4710, 25),
      ))
    }

@delegate:ResourceContentHash(1_638_517_165)
internal val Res.string.tour_post_body: StringResource by lazy {
      StringResource("string:tour_post_body", "tour_post_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7232, 266),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5548, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4736, 126),
      ))
    }

@delegate:ResourceContentHash(-133_374_697)
internal val Res.string.tour_post_title: StringResource by lazy {
      StringResource("string:tour_post_title", "tour_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7499, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5699, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4863, 43),
      ))
    }

@delegate:ResourceContentHash(-574_951_925)
internal val Res.string.tour_profile_body: StringResource by lazy {
      StringResource("string:tour_profile_body", "tour_profile_body", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7579, 205),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5755, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4907, 121),
      ))
    }

@delegate:ResourceContentHash(-42_573_956)
internal val Res.string.tour_profile_title: StringResource by lazy {
      StringResource("string:tour_profile_title", "tour_profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7785, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5873, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5029, 42),
      ))
    }

@delegate:ResourceContentHash(1_350_352_312)
internal val Res.string.tour_skip: StringResource by lazy {
      StringResource("string:tour_skip", "tour_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7840, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5916, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5072, 25),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_add_claim_business", Res.string.action_add_claim_business)
  map.put("action_continue_as_user", Res.string.action_continue_as_user)
  map.put("action_retry", Res.string.action_retry)
  map.put("action_sign_in", Res.string.action_sign_in)
  map.put("app_name", Res.string.app_name)
  map.put("app_tagline", Res.string.app_tagline)
  map.put("delete_account_cancel", Res.string.delete_account_cancel)
  map.put("delete_account_confirm", Res.string.delete_account_confirm)
  map.put("delete_account_failed", Res.string.delete_account_failed)
  map.put("delete_account_password_label", Res.string.delete_account_password_label)
  map.put("delete_account_title", Res.string.delete_account_title)
  map.put("delete_account_warning", Res.string.delete_account_warning)
  map.put("delete_account_wrong_password", Res.string.delete_account_wrong_password)
  map.put("gate_debug_dismiss", Res.string.gate_debug_dismiss)
  map.put("gate_maintenance_message_default", Res.string.gate_maintenance_message_default)
  map.put("gate_maintenance_title", Res.string.gate_maintenance_title)
  map.put("gate_retry", Res.string.gate_retry)
  map.put("gate_update_button", Res.string.gate_update_button)
  map.put("gate_update_message_default", Res.string.gate_update_message_default)
  map.put("gate_update_title", Res.string.gate_update_title)
  map.put("label_sponsored", Res.string.label_sponsored)
  map.put("label_verified", Res.string.label_verified)
  map.put("mock_data_banner", Res.string.mock_data_banner)
  map.put("nav_events", Res.string.nav_events)
  map.put("nav_feed", Res.string.nav_feed)
  map.put("nav_home", Res.string.nav_home)
  map.put("nav_market", Res.string.nav_market)
  map.put("nav_messages", Res.string.nav_messages)
  map.put("nav_notifications", Res.string.nav_notifications)
  map.put("nav_notifications_unread_a11y", Res.string.nav_notifications_unread_a11y)
  map.put("nav_post", Res.string.nav_post)
  map.put("nav_profile", Res.string.nav_profile)
  map.put("offline_banner", Res.string.offline_banner)
  map.put("owner_welcome_body", Res.string.owner_welcome_body)
  map.put("owner_welcome_later", Res.string.owner_welcome_later)
  map.put("owner_welcome_title", Res.string.owner_welcome_title)
  map.put("owner_welcome_tour", Res.string.owner_welcome_tour)
  map.put("placeholder_desc", Res.string.placeholder_desc)
  map.put("placeholder_title", Res.string.placeholder_title)
  map.put("post_action_ask", Res.string.post_action_ask)
  map.put("post_action_business", Res.string.post_action_business)
  map.put("post_action_feed", Res.string.post_action_feed)
  map.put("post_action_market", Res.string.post_action_market)
  map.put("post_guest_cta", Res.string.post_guest_cta)
  map.put("post_guest_message", Res.string.post_guest_message)
  map.put("post_guest_title", Res.string.post_guest_title)
  map.put("post_sheet_title", Res.string.post_sheet_title)
  map.put("prod_preview_banner", Res.string.prod_preview_banner)
  map.put("search_placeholder", Res.string.search_placeholder)
  map.put("share_copy_link", Res.string.share_copy_link)
  map.put("share_instagram_hint", Res.string.share_instagram_hint)
  map.put("share_more_options", Res.string.share_more_options)
  map.put("share_sheet_title", Res.string.share_sheet_title)
  map.put("sunset_banner_default", Res.string.sunset_banner_default)
  map.put("sunset_dismiss_a11y", Res.string.sunset_dismiss_a11y)
  map.put("tour_done", Res.string.tour_done)
  map.put("tour_events_body", Res.string.tour_events_body)
  map.put("tour_events_title", Res.string.tour_events_title)
  map.put("tour_feed_body", Res.string.tour_feed_body)
  map.put("tour_feed_title", Res.string.tour_feed_title)
  map.put("tour_home_body", Res.string.tour_home_body)
  map.put("tour_home_title", Res.string.tour_home_title)
  map.put("tour_market_body", Res.string.tour_market_body)
  map.put("tour_market_title", Res.string.tour_market_title)
  map.put("tour_messages_body", Res.string.tour_messages_body)
  map.put("tour_messages_title", Res.string.tour_messages_title)
  map.put("tour_next", Res.string.tour_next)
  map.put("tour_post_body", Res.string.tour_post_body)
  map.put("tour_post_title", Res.string.tour_post_title)
  map.put("tour_profile_body", Res.string.tour_profile_body)
  map.put("tour_profile_title", Res.string.tour_profile_title)
  map.put("tour_skip", Res.string.tour_skip)
}
